import React from 'react';
import { withForm, withFormValidation } from 'hoc';
import { get } from 'lodash';
import { useQuery } from 'hooks';
import { useLocation } from 'react-router-dom';

export default function ProvisionalAuthority() {
  const urlParams = new URLSearchParams(useLocation().search);
  return (
    <div className="w-full h-full">
      <iframe
        title="Provisional Authority"
        className="w-full h-full"
        style={{ height: '100vh' }}
        src={`${process.env.REACT_APP_ENPOINT}site/provisional_authority?jwt=${urlParams.get('jwt')}`}/>
    </div>
  );
}
